"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var apiName = 'Motusi';
var paginateRequest = function (api, pagination, howMany) {
    if (pagination === void 0) { pagination = { page: 1, limit: 20 }; }
    if (howMany === void 0) { howMany = 50; }
    return __awaiter(void 0, void 0, void 0, function () {
        var result, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    pagination.limit = howMany < pagination.limit ? howMany : pagination.limit;
                    return [4, api(pagination)];
                case 1:
                    result = _c.sent();
                    howMany -= result.length;
                    if (!((result === null || result === void 0 ? void 0 : result.length) >= pagination.limit && howMany > 0)) return [3, 3];
                    pagination.page++;
                    _b = (_a = result).concat;
                    return [4, paginateRequest(api, pagination, howMany)];
                case 2: return [2, _b.apply(_a, [_c.sent()])];
                case 3: return [2, result];
            }
        });
    });
};
module.exports = function (API) {
    return {
        paginateRequest: paginateRequest,
        registerMobileApp: function (serialNumber, publicKey) {
            return __awaiter(this, void 0, void 0, function () {
                var response, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            console.log('calling-register-mobile-app', serialNumber, publicKey);
                            return [4, API.post(apiName, '/register', {
                                    body: {
                                        serialNumber: serialNumber,
                                        publicKey: publicKey,
                                    },
                                })];
                        case 1:
                            response = _a.sent();
                            return [2, response];
                        case 2:
                            e_1 = _a.sent();
                            console.log('register-mobile-app-error', e_1, e_1.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        createDataset: function (_a) {
            var movementId = _a.movementId, dataset = _a.dataset, _b = _a.memberId, memberId = _b === void 0 ? null : _b, _c = _a.marks, marks = _c === void 0 ? [] : _c, _d = _a.note, note = _d === void 0 ? null : _d, _e = _a.comment, comment = _e === void 0 ? null : _e;
            return __awaiter(this, void 0, void 0, function () {
                var body, response, e_2;
                return __generator(this, function (_f) {
                    switch (_f.label) {
                        case 0:
                            _f.trys.push([0, 3, , 4]);
                            body = Object.assign({
                                movementId: movementId,
                                marks: marks,
                            }, memberId && { memberId: memberId }, note && { note: note }, comment && { comment: comment });
                            return [4, API.post(apiName, '/upload', { body: body })];
                        case 1:
                            response = _f.sent();
                            return [4, fetch(response.signedUrl, {
                                    method: 'PUT',
                                    body: JSON.stringify(dataset),
                                })];
                        case 2:
                            _f.sent();
                            return [2, response.id];
                        case 3:
                            e_2 = _f.sent();
                            console.log('create-dataset-error', e_2, e_2.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        updateDataset: function (datasetId, note) {
            return __awaiter(this, void 0, void 0, function () {
                var response, e_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, API.put(apiName, "/programs/movements/datasets/" + datasetId, {
                                    body: {
                                        note: note,
                                    },
                                })];
                        case 1:
                            response = _a.sent();
                            return [2, response.result];
                        case 2:
                            e_3 = _a.sent();
                            console.log('update-dataset-error', e_3, e_3.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        deleteDataset: function (datasetId) {
            return __awaiter(this, void 0, void 0, function () {
                var response, e_4;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, API.del(apiName, "/programs/movements/datasets/" + datasetId)];
                        case 1:
                            response = _a.sent();
                            return [2, response];
                        case 2:
                            e_4 = _a.sent();
                            console.log('delete-dataset-error', e_4, e_4.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        getDatasetsForMovement: function (movementId, filter) {
            if (filter === void 0) { filter = { page: 1, limit: 20 }; }
            return __awaiter(this, void 0, void 0, function () {
                var url, datasetsResponse, e_5;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/programs/movements/" + movementId + "/datasets";
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            return [4, API.get(apiName, url, {
                                    queryStringParameters: filter,
                                })];
                        case 2:
                            datasetsResponse = _a.sent();
                            return [4, Promise.all(datasetsResponse.data.map(function (e) { return __awaiter(_this, void 0, void 0, function () {
                                    var datasetSignedUrlResponse, downloadResult, data, marks, err_1;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                _a.trys.push([0, 5, , 6]);
                                                return [4, API.get(apiName, "/datasets/" + e.id + "/file")];
                                            case 1:
                                                datasetSignedUrlResponse = _a.sent();
                                                return [4, fetch(datasetSignedUrlResponse.signedUrl, {
                                                        method: 'GET',
                                                    })];
                                            case 2:
                                                downloadResult = _a.sent();
                                                return [4, downloadResult.json()];
                                            case 3:
                                                data = _a.sent();
                                                data.dataset.movementId = movementId;
                                                data.dataset.id = e.id;
                                                return [4, API.get(apiName, "/programs/movements/datasets/" + e.id + "/marks")];
                                            case 4:
                                                marks = _a.sent();
                                                data.dataset.timelineTags = marks.data;
                                                return [2, data];
                                            case 5:
                                                err_1 = _a.sent();
                                                console.log('get-datasets-for-movement-error', err_1, err_1.response);
                                                return [3, 6];
                                            case 6: return [2];
                                        }
                                    });
                                }); }))];
                        case 3: return [2, _a.sent()];
                        case 4:
                            e_5 = _a.sent();
                            console.log('get-datasets-error', e_5, e_5.response);
                            return [3, 5];
                        case 5: return [2];
                    }
                });
            });
        },
        searchDatasets: function (query, pagination) {
            if (query === void 0) { query = {}; }
            if (pagination === void 0) { pagination = { page: 1, limit: 20 }; }
            return __awaiter(this, void 0, void 0, function () {
                var url, queryStringParameters, response, e_6;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            url = '/sys/datasets-search';
                            queryStringParameters = __assign(__assign({}, query), pagination);
                            return [4, API.get(apiName, url, {
                                    queryStringParameters: queryStringParameters,
                                })];
                        case 1:
                            response = _a.sent();
                            return [2, response.data];
                        case 2:
                            e_6 = _a.sent();
                            console.log('search-datasets-error', e_6, e_6.code);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        downloadSingleDataset: function (datasetId) {
            return __awaiter(this, void 0, void 0, function () {
                var datasetSignedUrlResponse, downloadResult, data, marks, err_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 5, , 6]);
                            return [4, API.get(apiName, "/datasets/" + datasetId + "/file")];
                        case 1:
                            datasetSignedUrlResponse = _a.sent();
                            return [4, fetch(datasetSignedUrlResponse.signedUrl, {
                                    method: 'GET',
                                })];
                        case 2:
                            downloadResult = _a.sent();
                            return [4, downloadResult.json()];
                        case 3:
                            data = _a.sent();
                            data.dataset.id = datasetId;
                            return [4, API.get(apiName, "/programs/movements/datasets/" + datasetId + "/marks")];
                        case 4:
                            marks = _a.sent();
                            data.dataset.timelineTags = marks.data;
                            return [2, data.dataset];
                        case 5:
                            err_2 = _a.sent();
                            console.log('download-single-dataset-error', err_2, err_2.response);
                            return [3, 6];
                        case 6: return [2];
                    }
                });
            });
        },
        createMotionMark: function (datasetId, mark) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, e_7;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            url = "/programs/movements/datasets/" + datasetId + "/marks";
                            return [4, API.post(apiName, url, {
                                    body: mark,
                                })];
                        case 1:
                            response = _a.sent();
                            return [2, response];
                        case 2:
                            e_7 = _a.sent();
                            console.log('create-motion-mark-error', e_7, e_7.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        deleteMotionMark: function (datasetId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, e_8;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            url = "/programs/movements/datasets/marks/" + datasetId;
                            return [4, API.del(apiName, url)];
                        case 1:
                            response = _a.sent();
                            return [2, response === null || response === void 0 ? void 0 : response.result];
                        case 2:
                            e_8 = _a.sent();
                            console.log('delete-motion-mark-error', e_8, e_8.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        getMotionMarks: function (datasetId, pagination) {
            if (pagination === void 0) { pagination = { page: 1, limit: 20 }; }
            return __awaiter(this, void 0, void 0, function () {
                var url, queryStringParameters, response, e_9;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            url = "/programs/movements/datasets/" + datasetId + "/marks";
                            queryStringParameters = __assign({}, pagination);
                            return [4, API.get(apiName, url, {
                                    queryStringParameters: queryStringParameters,
                                })];
                        case 1:
                            response = _a.sent();
                            return [2, response.data];
                        case 2:
                            e_9 = _a.sent();
                            console.log('get-motion-marks-error', e_9, e_9.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        createDatasetComment: function (datasetId, comment, parentId) {
            if (parentId === void 0) { parentId = null; }
            return __awaiter(this, void 0, void 0, function () {
                var url, body, response, e_10;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            url = "/programs/movements/datasets/" + datasetId + "/comments";
                            body = Object.assign({
                                comment: comment,
                            }, parentId && { parentId: parentId });
                            return [4, API.post(apiName, url, { body: body })];
                        case 1:
                            response = _a.sent();
                            return [2, response.commentId];
                        case 2:
                            e_10 = _a.sent();
                            console.log('create-dataset-comment-error', e_10, e_10.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        getDatasetComments: function (datasetId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, e_11;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            url = "/programs/movements/datasets/" + datasetId + "/comments";
                            return [4, API.get(apiName, url)];
                        case 1:
                            response = _a.sent();
                            return [2, response.data];
                        case 2:
                            e_11 = _a.sent();
                            console.log('get-dataset-comments-error', e_11, e_11.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        updateDatasetComment: function (datasetId, comment) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, e_12;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            url = "/programs/movements/datasets/comments/" + datasetId;
                            return [4, API.post(apiName, url, { body: { comment: comment } })];
                        case 1:
                            response = _a.sent();
                            return [2, response];
                        case 2:
                            e_12 = _a.sent();
                            console.log('update-dataset-comment-error', e_12, e_12.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        deleteDatasetComment: function (datasetId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, e_13;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            url = "/programs/movements/datasets/comments/" + datasetId;
                            return [4, API.del(apiName, url)];
                        case 1:
                            response = _a.sent();
                            return [2, response];
                        case 2:
                            e_13 = _a.sent();
                            console.log('delete-dataset-comment-error', e_13, e_13.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        createTag: function (body) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, e_14;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            url = '/tags';
                            return [4, API.post(apiName, url, { body: body })];
                        case 1:
                            response = _a.sent();
                            return [2, response];
                        case 2:
                            e_14 = _a.sent();
                            console.log('create-tag-error', e_14, e_14.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        getTags: function (filter) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, e_15;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            url = '/tags';
                            return [4, API.get(apiName, url, {
                                    queryStringParameters: filter,
                                })];
                        case 1:
                            response = _a.sent();
                            return [2, response.data];
                        case 2:
                            e_15 = _a.sent();
                            console.log('get-tags-error', e_15, e_15.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        getProfileTags: function (profileId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, e_16;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            url = "/profile/" + profileId + "/tags";
                            return [4, API.get(apiName, url)];
                        case 1:
                            response = _a.sent();
                            return [2, response.data];
                        case 2:
                            e_16 = _a.sent();
                            console.log('get-profile-tags-error', e_16, e_16.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        addProfileTags: function (profileId, tagIds) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, e_17;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            url = "/profile/" + profileId + "/tags";
                            return [4, API.post(apiName, url, { body: { tagIds: tagIds } })];
                        case 1:
                            response = _a.sent();
                            return [2, response.data];
                        case 2:
                            e_17 = _a.sent();
                            console.log('add-profile-tags-error', e_17, e_17.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        removeProfileTag: function (profileId, tagId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, e_18;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            url = "/profile/" + profileId + "/tags/" + tagId;
                            return [4, API.del(apiName, url)];
                        case 1:
                            response = _a.sent();
                            return [2, response.data];
                        case 2:
                            e_18 = _a.sent();
                            console.log('remove-profile-tag-error', e_18, e_18.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        getDatasetTags: function (datasetId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, e_19;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            url = "/programs/movements/datasets/" + datasetId + "/tags";
                            return [4, API.get(apiName, url)];
                        case 1:
                            response = _a.sent();
                            return [2, response.data];
                        case 2:
                            e_19 = _a.sent();
                            console.log('get-dataset-tags-error', e_19, e_19.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        addDatasetTags: function (datasetId, tagIds) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, e_20;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            url = "/programs/movements/datasets/" + datasetId + "/tags";
                            return [4, API.post(apiName, url, { body: { tagIds: tagIds } })];
                        case 1:
                            response = _a.sent();
                            return [2, response.data];
                        case 2:
                            e_20 = _a.sent();
                            console.log('add-dataset-tags-error', e_20, e_20.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        removeDatasetTag: function (datasetId, tagId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, e_21;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            url = "/programs/movements/datasets/" + datasetId + "/tags/" + tagId;
                            return [4, API.del(apiName, url)];
                        case 1:
                            response = _a.sent();
                            return [2, response.data];
                        case 2:
                            e_21 = _a.sent();
                            console.log('remove-dataset-tag-error', e_21, e_21.response);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        },
        createProgram: function (params) {
            return __awaiter(this, void 0, void 0, function () {
                var response, e_22;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!params.description) {
                                delete params.description;
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.post(apiName, '/me/programs', {
                                    body: params,
                                })];
                        case 2:
                            response = _a.sent();
                            return [2, response.id];
                        case 3:
                            e_22 = _a.sent();
                            console.log('create-program-error', e_22, e_22.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        getPrograms: function (pagination) {
            if (pagination === void 0) { pagination = { page: 1, limit: 20 }; }
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_23;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = '/me/programs';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.get(apiName, url, {
                                    queryStringParameters: __assign({}, pagination),
                                })];
                        case 2:
                            result = _a.sent();
                            return [2, result.data];
                        case 3:
                            e_23 = _a.sent();
                            console.log('get-programs-error', e_23, e_23.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        deleteProgram: function (programId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_24;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/programs/" + programId;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.del(apiName, url)];
                        case 2:
                            result = _a.sent();
                            return [2, result];
                        case 3:
                            e_24 = _a.sent();
                            console.log('delete-program-error', e_24);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        addMovementToProgram: function (programId, movement) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, e_25;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/programs/" + programId + "/movements";
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.post(apiName, url, {
                                    body: movement,
                                })];
                        case 2:
                            response = _a.sent();
                            return [2, response.id];
                        case 3:
                            e_25 = _a.sent();
                            console.log('add-movement-error', e_25, e_25.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        updateProgramMovements: function (movements) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, e_26;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = '/programs/movements';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.put(apiName, url, {
                                    body: { movements: movements },
                                })];
                        case 2:
                            response = _a.sent();
                            return [2, response];
                        case 3:
                            e_26 = _a.sent();
                            console.log('update-program-movements', e_26, e_26.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        updateProgram: function (program) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response, e_27;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/programs/" + program.id;
                            if (!program.description) {
                                program.description = 'placeholder';
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.put(apiName, url, {
                                    body: program,
                                })];
                        case 2:
                            response = _a.sent();
                            return [2, response];
                        case 3:
                            e_27 = _a.sent();
                            console.log('update-program-err', e_27, e_27.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        deleteMovementFromProgram: function (movementId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, e_28;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/programs/movements/" + movementId;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.del(apiName, url)];
                        case 2:
                            _a.sent();
                            return [3, 4];
                        case 3:
                            e_28 = _a.sent();
                            console.log('delete-mvmt-from-program', e_28, e_28.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        getSpacePrograms: function (spaceId, filter) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_29;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/" + spaceId + "/programs";
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.get(apiName, url, {
                                    queryStringParameters: filter,
                                })];
                        case 2:
                            result = _a.sent();
                            return [2, result.data];
                        case 3:
                            e_29 = _a.sent();
                            console.log('get-space-programs-error', e_29, e_29.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        getProgramDetail: function (programId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_30;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/programs/" + programId;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.get(apiName, url)];
                        case 2:
                            result = _a.sent();
                            return [2, result];
                        case 3:
                            e_30 = _a.sent();
                            console.log('get-program-detail-error', e_30, e_30.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        createSpaceProgram: function (spaceId, body) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_31;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/" + spaceId + "/programs";
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.post(apiName, url, {
                                    body: body,
                                })];
                        case 2:
                            result = _a.sent();
                            return [2, result.id];
                        case 3:
                            e_31 = _a.sent();
                            console.log('create-space-programs-error', e_31, e_31.response);
                            return [2, null];
                        case 4: return [2];
                    }
                });
            });
        },
        assignProgramToMember: function (programId, assigneeId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_32;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/programs/" + programId + "/assign";
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.post(apiName, url, {
                                    body: {
                                        assigneeId: assigneeId,
                                    },
                                })];
                        case 2:
                            result = _a.sent();
                            return [2, result];
                        case 3:
                            e_32 = _a.sent();
                            console.log('assign-program-error', e_32, e_32.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        copyProgramToMember: function (params) {
            return __awaiter(this, void 0, void 0, function () {
                var programId, assigneeId, spaceId, proId, url, body, result, e_33;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            programId = params.programId, assigneeId = params.assigneeId, spaceId = params.spaceId, proId = params.proId;
                            url = "/spaces/programs/" + programId + "/copyfor";
                            body = Object.assign({
                                assigneeId: assigneeId,
                                spaceId: spaceId,
                            }, proId && { proId: proId });
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.post(apiName, url, { body: body })];
                        case 2:
                            result = _a.sent();
                            return [2, result];
                        case 3:
                            e_33 = _a.sent();
                            console.log('copy-program-error', e_33, e_33.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        createProfile: function (profile) {
            return __awaiter(this, void 0, void 0, function () {
                var path, response, e_34;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            path = '/me/profile';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.put(apiName, path, {
                                    body: profile,
                                })];
                        case 2:
                            response = _a.sent();
                            return [2, response.id];
                        case 3:
                            e_34 = _a.sent();
                            console.log('createProfileError', e_34);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        getProfile: function () {
            var _a, _b, _c;
            return __awaiter(this, void 0, void 0, function () {
                var path, profile, e_35;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            path = '/me/profile';
                            _d.label = 1;
                        case 1:
                            _d.trys.push([1, 3, , 4]);
                            return [4, API.get(apiName, path, {
                                    queryStringParameters: {
                                        withPhoto: true,
                                        withEmail: true,
                                    },
                                })];
                        case 2:
                            profile = _d.sent();
                            return [2, profile];
                        case 3:
                            e_35 = _d.sent();
                            if (((_c = (_b = (_a = e_35.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) === null || _c === void 0 ? void 0 : _c.name) === 'ProfileNotFoundError') {
                                console.log('getProfile', e_35.response.data.error);
                            }
                            else {
                                throw e_35;
                            }
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        updateProfile: function (profile) {
            return __awaiter(this, void 0, void 0, function () {
                var profileUpdateObj, path, e_36;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            profileUpdateObj = {
                                firstName: profile.firstName,
                                lastName: profile.lastName,
                                phoneNumber: profile.phoneNumber,
                            };
                            path = '/me/profile';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.put(apiName, path, {
                                    body: profileUpdateObj,
                                })];
                        case 2:
                            _a.sent();
                            return [3, 4];
                        case 3:
                            e_36 = _a.sent();
                            console.log('updateProfileError', e_36);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        uploadProfilePicture: function (photo) {
            return __awaiter(this, void 0, void 0, function () {
                var path, uploadDetails_1, formData_1, fileDetails, e_37;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            path = '/me/profile/photo-upload-link';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            return [4, API.get(apiName, path)];
                        case 2:
                            uploadDetails_1 = _a.sent();
                            formData_1 = new FormData();
                            Object.keys(uploadDetails_1.fields).forEach(function (e) {
                                formData_1.append(e, uploadDetails_1.fields[e]);
                            });
                            fileDetails = {
                                uri: photo.uri,
                                name: 'profilePicture.jpeg',
                                type: 'image/jpeg',
                            };
                            formData_1.append('file', fileDetails);
                            return [4, fetch(uploadDetails_1.url, {
                                    method: 'POST',
                                    body: formData_1,
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                    },
                                })];
                        case 3:
                            _a.sent();
                            return [3, 5];
                        case 4:
                            e_37 = _a.sent();
                            console.log('uploadProfilePicture', e_37, e_37.response);
                            return [3, 5];
                        case 5: return [2];
                    }
                });
            });
        },
        invitePairingByEmail: function (userEmail, spaceId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_38;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/" + spaceId + "/assignment-invites";
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.post(apiName, url, {
                                    body: {
                                        email: userEmail,
                                    },
                                })];
                        case 2:
                            result = _a.sent();
                            return [2, result.assigmentInviteId];
                        case 3:
                            e_38 = _a.sent();
                            console.log('invite-user-error', e_38, e_38.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        getPendingPairingInvitesForSelf: function (page, limit) {
            if (page === void 0) { page = 1; }
            if (limit === void 0) { limit = 10; }
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_39;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = '/me/assignment-invites';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.get(apiName, url, {
                                    queryStringParameters: {
                                        page: page,
                                        limit: limit,
                                        status: 1,
                                    },
                                })];
                        case 2:
                            result = _a.sent();
                            return [2, result.data];
                        case 3:
                            e_39 = _a.sent();
                            console.log('invite-list-error', e_39, e_39.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        getPendingSpaceInvitesForSelf: function (page, limit) {
            if (page === void 0) { page = 1; }
            if (limit === void 0) { limit = 10; }
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_40;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = '/me/space-invites';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.get(apiName, url, {
                                    queryStringParameters: {
                                        page: page,
                                        limit: limit,
                                        status: 1,
                                    },
                                })];
                        case 2:
                            result = _a.sent();
                            return [2, result.data];
                        case 3:
                            e_40 = _a.sent();
                            console.log('member-space-invite-list-error', e_40, e_40.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        getTeamPairingsForMember: function (filter) {
            if (filter === void 0) { filter = {}; }
            return __awaiter(this, void 0, void 0, function () {
                var passFilter, url, result, e_41;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            passFilter = Object.assign({
                                page: 1,
                                limit: 10,
                                withProPhoto: true,
                            }, filter);
                            url = '/me/assignments';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.get(apiName, url, {
                                    queryStringParameters: passFilter,
                                })];
                        case 2:
                            result = _a.sent();
                            return [2, result.data];
                        case 3:
                            e_41 = _a.sent();
                            console.log('get-member-pairings-error', e_41, e_41.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        getTeamPairingsForProInSpace: function (spaceId, proId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_42;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/" + spaceId + "/assignments";
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.get(apiName, url, {
                                    queryStringParameters: {
                                        proId: proId,
                                        staffId: proId,
                                    },
                                })];
                        case 2:
                            result = _a.sent();
                            return [2, result.data];
                        case 3:
                            e_42 = _a.sent();
                            console.log('get-pro-pairings-error', e_42, e_42.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        getPairingInvites: function (filter) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_43;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = '/spaces/assignment-invites';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.get(apiName, url, {
                                    queryStringParameters: filter,
                                })];
                        case 2:
                            result = _a.sent();
                            return [2, result.data];
                        case 3:
                            e_43 = _a.sent();
                            console.log('get-pro-pairings-error', e_43, e_43.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        resendSpaceInvite: function (token) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_44;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/invitations/" + token;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.put(apiName, url)];
                        case 2:
                            result = _a.sent();
                            return [2, result];
                        case 3:
                            e_44 = _a.sent();
                            console.log('resend-space-invite-error', e_44, e_44.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        cancelSpaceInvite: function (token) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_45;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/invitations/" + token;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.del(apiName, url)];
                        case 2:
                            result = _a.sent();
                            return [2, result];
                        case 3:
                            e_45 = _a.sent();
                            console.log('cancel-space-invite-error', e_45, e_45.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        resendPairInvite: function (token) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_46;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/assignment-invites/" + token;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.put(apiName, url)];
                        case 2:
                            result = _a.sent();
                            return [2, result];
                        case 3:
                            e_46 = _a.sent();
                            console.log('resend-pair-invite-error', e_46, e_46.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        cancelPairInvite: function (token) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_47;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/assignment-invites/" + token;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.del(apiName, url)];
                        case 2:
                            result = _a.sent();
                            return [2, result];
                        case 3:
                            e_47 = _a.sent();
                            console.log('cancel-pair-invite-error', e_47, e_47.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        getMembersInSpace: function (spaceId, filters) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_48;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/" + spaceId + "/members";
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.get(apiName, url, {
                                    queryStringParameters: filters,
                                })];
                        case 2:
                            result = _a.sent();
                            return [2, result.data];
                        case 3:
                            e_48 = _a.sent();
                            console.log('get-members-in-space-error', e_48, e_48.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        getProsInSpace: function (spaceId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_49;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/" + spaceId + "/staff";
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.get(apiName, url, {
                                    queryStringParameters: {
                                        role: 2,
                                    },
                                })];
                        case 2:
                            result = _a.sent();
                            return [2, result.data];
                        case 3:
                            e_49 = _a.sent();
                            console.log('get-pros-in-space-error', e_49, e_49.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        acceptPairingInviteForSelf: function (token) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_50;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = '/me/assignment-invites/acceptance';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.post(apiName, url, {
                                    body: {
                                        token: token,
                                    },
                                })];
                        case 2:
                            result = _a.sent();
                            return [2, result.result];
                        case 3:
                            e_50 = _a.sent();
                            console.log('accept-invite-error', e_50, e_50.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        unpairFromPro: function (assignmentId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_51;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/me/assignments/" + assignmentId;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.del(apiName, url)];
                        case 2:
                            result = _a.sent();
                            return [2, result];
                        case 3:
                            e_51 = _a.sent();
                            console.log('delete-own-assignment-error', e_51, e_51.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        getSpacesForUser: function () {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_52;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = '/me/spaces?includeExtraDetails=true';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.get(apiName, url)];
                        case 2:
                            result = _a.sent();
                            return [2, result.data];
                        case 3:
                            e_52 = _a.sent();
                            console.log('get-user-spaces-error', e_52, e_52.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        getSpace: function (spaceId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_53;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/" + spaceId + "/profile";
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.get(apiName, url)];
                        case 2:
                            result = _a.sent();
                            return [2, result];
                        case 3:
                            e_53 = _a.sent();
                            console.log('get-space-error', e_53, e_53.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        deleteAssignmentAsAdmin: function (assignmentId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_54;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/assignments/" + assignmentId;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.del(apiName, url)];
                        case 2:
                            result = _a.sent();
                            return [2, result.result];
                        case 3:
                            e_54 = _a.sent();
                            console.log('admin-delete-assignment-error', e_54, e_54.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        acceptSpaceInvite: function (token) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_55;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = '/me/invitations/accept';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.post(apiName, url, {
                                    body: {
                                        token: token,
                                    },
                                })];
                        case 2:
                            result = _a.sent();
                            return [2, result.spaceId];
                        case 3:
                            e_55 = _a.sent();
                            console.log('space-invite-acceptance-error', e_55, e_55.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        createProfileForSpace: function (spaceId, title, phoneNumber) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_56;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/" + spaceId + "/me/profile";
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.put(apiName, url, {
                                    body: {
                                        title: title,
                                        phoneNumber: phoneNumber,
                                    },
                                })];
                        case 2:
                            result = _a.sent();
                            return [2, result];
                        case 3:
                            e_56 = _a.sent();
                            console.log('create-space-profile-error', e_56, e_56.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        getUserSpaceProfile: function (spaceId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_57;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/" + spaceId + "/me/profile";
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.get(apiName, url)];
                        case 2:
                            result = _a.sent();
                            return [2, result];
                        case 3:
                            e_57 = _a.sent();
                            console.log('get-user-space-profile-error', e_57, e_57.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        listSpacePairings: function (spaceId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_58;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/" + spaceId + "/assignments";
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.get(apiName, url)];
                        case 2:
                            result = _a.sent();
                            return [2, result];
                        case 3:
                            e_58 = _a.sent();
                            console.log('list-space-pairings-error', e_58, e_58.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        listSpacePairingInvites: function (spaceId) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_59;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/" + spaceId + "/assignment-invites";
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.get(apiName, url)];
                        case 2:
                            result = _a.sent();
                            return [2, result];
                        case 3:
                            e_59 = _a.sent();
                            console.log('list-space-pairing-invites-error', e_59, e_59.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
        createSpaceInviteViaEmailForRole: function (spaceId, email, role) {
            return __awaiter(this, void 0, void 0, function () {
                var url, result, e_60;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/spaces/" + spaceId + "/invitations";
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, API.post(apiName, url, {
                                    body: {
                                        email: email,
                                        role: role,
                                    },
                                })];
                        case 2:
                            result = _a.sent();
                            return [2, result];
                        case 3:
                            e_60 = _a.sent();
                            console.log('space-invite-error', e_60, e_60.response);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            });
        },
    };
};
//# sourceMappingURL=api.js.map